import * as React from 'react';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { ICustomPropertiesSectionProps } from './types';
import {
    CustomPropertiesHOC
} from '../../hocs/CustomPropertiesHOC/CustomPropertiesHOC';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { TutorialHOC } from '../../../Tutorial/hocs/TutorialHOC/TutorialHOC';

export function CustomPropertiesSection ({
}: ICustomPropertiesSectionProps) {
    const { boardId } = React.useContext(AsidePanelContext);

    return (
        <>
            <TutorialHOC boardSetting={EBoardSetting.CUSTOM_PROPERTIES} />
            <CustomPropertiesHOC boardId={boardId} />
        </>
    );
};
